import { render, staticRenderFns } from "./UCProductDetails.vue?vue&type=template&id=1ed699ad&scoped=true&"
import script from "./UCProductDetails.vue?vue&type=script&lang=ts&"
export * from "./UCProductDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UCProductDetails.vue?vue&type=style&index=0&id=1ed699ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed699ad",
  null
  
)

export default component.exports